

import { classesRuntime, statesRuntime } from "./../../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_TextComponent";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_TextComponent__root","text":"wds_1_209_0_TextComponent__text","suffix":"wds_1_209_0_TextComponent__suffix","multilineSuffixWrapper":"wds_1_209_0_TextComponent__multilineSuffixWrapper","multilineSuffix":"wds_1_209_0_TextComponent__multilineSuffix"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"maxLines":"--wds_1_209_0_TextComponent-maxLines"}; 




